import { USER_DATA_TABLES } from "./schema";

/**
 * Generates a query to check if there is local data for a given user.
 *
 * Only counts the REAL per-user product entities (`USER_DATA_TABLES`), scoped to
 * `userId` — exactly the rows `sweepVisitorData` re-parents on a guest→real
 * upgrade. It deliberately does NOT probe `ps_crud`: that upload queue also holds
 * the device-settings row the ThemeProvider seeds for every guest on boot (the
 * `user`/`themes` tables, which are NOT user data to migrate). Counting `ps_crud`
 * made the "Keep local data?" merge dialog fire spuriously on every clean guest
 * boot, blocking login. The table checks below stay in lock-step with the merge.
 */
// SOFT_DELETE (CC-34): tables with a trash feature count ONLY live rows. Without
// this, an exercise/routine in the trash would trigger the "Keep
// local data?" prompt when migrating from guest to real account (cohort leak: the
// invariant `deleted_at IS NULL` scattered). Keep in lock-step with
// `SOFT_DELETE_TABLES` in packages/shared/src/live/guard-manifest.ts.
const SOFT_DELETE_LOCAL_TABLES = new Set<string>(["exercise", "routine"]);

export const getHasLocalDataQuery = (userId: string) => {
  const tableChecks = USER_DATA_TABLES.map((table) => {
    const alive = SOFT_DELETE_LOCAL_TABLES.has(table) ? " AND deleted_at IS NULL" : "";
    return `      WHEN EXISTS (SELECT id FROM ${table} WHERE user_id = ?${alive} LIMIT 1) THEN 1`;
  }).join("\n");
  const params = Array.from({ length: USER_DATA_TABLES.length }).fill(userId);

  return {
    sql: `
    SELECT CASE
${tableChecks}
      ELSE 0
    END as hasData
  `,
    parameters: params,
  };
};
